import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import examples from '../../../utils/examples';
import urlHandler from '../../../utils/urlHandler';

class DocCutomEntitiesDelete extends Component {
    constructor(props){
        super(props);
    }        

    render() {
        return (
            <div className="bucket" id="top">
                <h3 className="heading-1">Delete Custom Entity</h3>
                <code className="api-definition">
                    <span className="delete-badge">DELETE</span>&nbsp;{urlHandler.API_ENDPOINT_V1_EXTRACTION_DELETE}
                </code>
                <div className="description">
                    <div className="deprecated">
                        <span className="fa fa-exclamation-triangle">&nbsp;</span>
                        This request is only available to on-prem customers of Finch For Text.
                    </div>
                    <div className="warn">
                        <span className="fa fa-comment">&nbsp;</span>
                        Not to be confused with “deleting an entity from a document”. 
                    </div>
                    <br/>
                    <b>Delete Custom Entity</b><br/>
                    <br/>
                    The delete endpoint allows for a user to delete a collection of entries from the user dictionary at once. This is intended for cleaning up your dictionary if some entries are no longer needed or are causing problems for your data. Unlike the insert endpoint, the dictionary will be updated regardless if warnings with the data are returned. 
                    <br />
                    On success the update should be effective immediately. There is no need for a server reload. These entries will no longer be in your user dictionary, and the next time FFT enrich is called, the corresponding entities should be present/suppressed if they exist in the document.
                    <br />              
                </div>

                <h4 className="heading-2">Request</h4>

                <h4 className="heading-3" id="enrichv2_request_object">Request object</h4>
                A JSON Custom Entity object is sent as the payload. The following link has a complete documentation for the <Link to="/documentation/doc_customentity#top">Custom Entity Fields</Link>
                <table className="table-wrapper enrich">
                    <thead className="table-header enrich">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Values </th>
                        <th>Default </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">entries</td>
                        <td className="meaning">A list of JSON entry objects to ADD or REMOVE tags from the output.
                        </td>
                        <td className="type">entry[]<br/>
                        entries schema documentation is found <Link to="/documentation/doc_customentity#custom_entity_entry_object">here</Link><br/></td>
                        <td className="type">
                            Required
                        </td>
                    </tr>
                    </tbody>
                </table>
                <h4 className="heading-3">Example</h4>
                <div className="example-content host">
                    <pre>
                    DELETE {urlHandler.API_ENDPOINT_V1_EXTRACTION_DELETE}<br/>
                    Accept: application/JSON<br/>
                    Authorization: Bearer [YOUR-API-KEY]<br/>
                    Content-Type: application/json<br/>
                    <br/>
                    {JSON.stringify(examples.EXAMPLE_REQUEST_DELETE, null, 3)}
                    </pre>
                </div>

                <h4 className="heading-2">Response</h4>

                <h4 className="heading-3">Response object</h4>
                <div className="description">
                    The response object contains a information on the status of the Custom Entity change as well as accessory information about the change.
                </div>
                <table className="table-wrapper enrich">
                    <thead className="table-header enrich">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Values </th>
                        <th>Default </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">code</td>
                        <td className="meaning">A specific code indicating a success, partial success, or failure.</td>
                        <td className="type">String</td>
                        <td className="constraints">Required</td>
                    </tr>
                    <tr>
                        <td className="attribute">message</td>
                        <td className="meaning">A simple message about what was completed.</td>
                        <td className="type">String</td>
                        <td className="constraints">Required</td>
                    </tr>
                    <tr>
                        <td className="attribute"><i>details</i></td>
                        <td className="meaning">A list of details regarding any issues with the request. May be empty if the request is a success.</td>
                        <td className="type">String[]</td>
                        <td className="constraints">Required</td>
                    </tr>
                    </tbody>
                </table>

                <h4 className="heading-3">Example</h4>
                <div className="example-content host">
                    <pre>
                        {JSON.stringify(examples.EXAMPLE_RESPONSE_EXTRACTION_DELETE, null, 3)}
                    </pre>
                </div>
                <h4 className="heading-3">Warning Example</h4>
                <div className="example-content host">
                    <pre>
                        {JSON.stringify(examples.EXAMPLE_RESPONSE_EXTRACTION_DELETE_WARNING, null, 3)}
                    </pre>
                </div>
                <h4 className="heading-3">Error Example</h4>
                <div className="example-content host">
                    <pre>
                        {JSON.stringify(examples.EXAMPLE_RESPONSE_EXTRACTION_DELETE_ERROR, null, 3)}
                    </pre>
                </div>
            </div>
        );
    }
}

export default DocCutomEntitiesDelete;